module.exports = __webpack_public_path__ + "img/default-white.d0800148.svg";